import { render, staticRenderFns } from "./JgpTreeItem3.vue?vue&type=template&id=ec91c8da&"
import script from "./JgpTreeItem3.vue?vue&type=script&lang=js&"
export * from "./JgpTreeItem3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports